import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ImagesState = {
  data: Record<string, { value: string }>; // Maps URLs to objects with a `value`
};

const initialState: ImagesState = {
  data: {}
};

const EncryptedImageSlice = createSlice({
  name: 'images',
  initialState,
  reducers: {
    setImageValue: (state, action: PayloadAction<{ url: string; value: string }>) => {
      const { url, value } = action.payload;
      state.data[url] = { value }; // Set the value for the given URL
    },
    removeImageValue: (state, action: PayloadAction<string>) => {
      const url = action.payload;
      delete state.data[url]; // Remove the URL from the state
    }
  }
});

// Export actions
export const { setImageValue, removeImageValue } = EncryptedImageSlice.actions;

// Export reducer
export const EncryptedImagReducers = EncryptedImageSlice.reducer;

// Selector to get the value for a specific URL
export const selectImageValue = (state: ImagesState, url: string): string | undefined => {
  return state.data[url]?.value;
};
